const Header: React.FC = () => {
  return (
    <>
      <h1 className="px-2 py-4 sm:px-5 sm:py-7 text-4xl md:text-6xl text-gray-900 text-center font-semibold">
        Lån til din nye bil
      </h1>
      <div className="text-base md:text-lg text-gray-700 text-center mx-2 sm:mx-5">
        <span className="block sm:inline-block whitespace-nowrap">
          <img
            src="/images/check-circle-alternate.svg"
            alt="tick"
            className="inline-block mb-1"
          />{" "}
          Ingen udbetaling eller pant i bilen 
        </span>
        <span className="block sm:inline-block whitespace-nowrap">
          <img
            src="/images/check-circle-alternate.svg"
            alt="tick"
            className="inline-block mb-1 ml-2"
          />{" "}
          Kredit op til 300.000 kr.
        </span>
        <span className="block sm:inline-block whitespace-nowrap">
          <img
            src="/images/check-circle-alternate.svg"
            alt="tick"
            className="inline-block mb-1 ml-2"
          />{" "}
          Få svar med det samme
        </span>
      </div>
    </>
  );
};

export default Header;
